import { render, staticRenderFns } from "./CmgRecentsAndFavoritesPage.vue?vue&type=template&id=d757ccd4&scoped=true&lang=pug&"
import script from "./cmg-recents-and-favorites-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-recents-and-favorites-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRecentsAndFavoritesPage.vue?vue&type=style&index=0&id=d757ccd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d757ccd4",
  null
  
)

export default component.exports